import { HSActiveConfiguration } from './HSActiveConfiguration';

export class SlidingDoorActiveConfiguration extends HSActiveConfiguration {
    type: 'sliding_door' = 'sliding_door';
}
